import styled from '@emotion/styled';

import {
  Calendar,
  ChevronRight,
  Internationalisation,
} from 'ms-components/icons';
import { FreeTextbooksBookDemoButton } from 'ms-pages/FreeTextbooks/FreeTextbooksBookDemoButton';
import { font, fontFamily, fontSize, lineHeight } from 'ms-styles/base/index';
import { colors } from 'ms-styles/colors';
import AnchorButton from 'ms-ui-primitives/Button/AnchorButton';
import Separator from 'ms-ui-primitives/Separator';
import { HSpacer, HStack } from 'ms-ui-primitives/Stack';
import { multilineTextOverflow, tappable } from 'ms-utils/emotion';

const LinksWrapper = styled.div({
  fontFamily: fontFamily.body,
});

const LineSeparator = styled.div({
  height: 2,
  backgroundColor: colors.grey90,
  marginTop: 24,
  marginBottom: 24,
});

const SubTitle = styled.h2({
  ...multilineTextOverflow(2),
  ...font.gilroyExtraLargeHeading,
  ...tappable,
  fontSize: fontSize.large,
  lineHeight: lineHeight.title,
  color: colors.almond50,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: 40,
  paddingBottom: 40,
});

export function FreeTextbooksFooterLinks() {
  return (
    <LinksWrapper>
      <LineSeparator />
      <SubTitle>Mathspace does more than this!</SubTitle>
      <HStack>
        <HStack center>
          <Calendar color={colors.almond50} />
          <FreeTextbooksBookDemoButton
            color="almond50"
            type="tertiary"
            snowplowEventLabel="footer-links"
            buttonLabel="Book a demo"
            trackingId="FreeTextbook/Footer/BookDemo"
          />
          <ChevronRight size={16} color={colors.almond50} />
        </HStack>
        <HSpacer width={16} />
        <HStack center>
          <AnchorButton
            color="almond50"
            type="tertiary"
            href="/"
            label="Visit our website"
            trackingId="FreeTextbook/Footer/VisitWebsite"
          >
            <Internationalisation size={16} color={colors.almond50} />
            <HSpacer width={16} />
            Visit our website
            <HSpacer width={16} />
            <ChevronRight size={16} color={colors.almond50} />
          </AnchorButton>
        </HStack>
      </HStack>
      <Separator size={10} />
    </LinksWrapper>
  );
}
